import React, { useState, useEffect, useRef } from "react"
import { OnPageNav, InPageJumpNav } from "terra-one"
import { SubNav } from "terra-one"
import { SiteNavigation } from "trimble-terra"
import { navigate } from "gatsby"
import { getTrialFormId } from "../../utils/functions/getTrialForm"
import { refreshAuthToken } from "../../utils/functions/refreshAuthToken"
const SiteNavigationHandler = ({
  data,
  history,
  applicationData = {},
  saveLanguage = () => {},
  Link,
  searchComponent,
  searchDeployed,
  setSearchDeployed,
  globalSearch,
  setGlobalSearch,
  showJumpNav,
  jumpNavItems,
  navRef,
  isCartFlyoutOpen = false,
  onCartFlyoutOpen,
  cartData,
  cartSettings,
  onCartRemoveItem,
  onCartChangeQuantity,
  currencies = [],
  defaultCurrency = "USD",
  activeCurrency = "USD",
  setCurrency,
  isCurrencyLocked = false,
  onPageNavData,
  alertHolderComponent,
  innerPageNavData,
  flyout,
  refreshTokenKeys,
}) => {
  const [languageSelectorDeployed, setLanguageSelectorDeployed] =
    useState(false)
  const languageEnabled = applicationData?.languageEnabled
  const [sectorFlyoutOpen, setSectorFlyoutOpen] = useState(false)
  const [desktopSearchDeployed, setDesktopSearchDeployed] =
    useState(searchDeployed)
  const [isCartFlyoutActive, setCartFlyoutActive] = useState(isCartFlyoutOpen)
  const [currentOpenMegaMenu, setCurrentOpenMegaMenu] = useState(null)
  const [sectorFlyoutDeployed, setSectorFlyoutDeployed] = useState(false)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const [isHidden, setIsHidden] = useState(false)
  const [currentOpenMenu, setCurrentOpenMenu] = useState(null)
  const [hamburgerIsOpen, setHamburgerIsOpen] = useState(false)
  const [lastPosition, _setLastPosition] = useState(100)
  const lastPositionRef = useRef(lastPosition)
  const setLastPosition = data => {
    lastPositionRef.current = data
    _setLastPosition(data)
  }

  const subNavDisplay =
    innerPageNavData?.breadcrumbs?.length > 0 ||
    innerPageNavData?.siblingPages?.length > 0

  useEffect(() => {
    setDesktopSearchDeployed(searchDeployed)
  }, [searchDeployed])

  useEffect(() => {
    setCartFlyoutActive(isCartFlyoutOpen)
  }, [isCartFlyoutOpen])

  useEffect(() => {
    setSearchDeployed(desktopSearchDeployed)
  }, [desktopSearchDeployed])

  useEffect(() => {
    if (typeof onCartFlyoutOpen === "function") {
      onCartFlyoutOpen(isCartFlyoutActive)
    }
  }, [isCartFlyoutActive])

  useEffect(() => {
    if(mobileNavOpen && typeof window !== "undefined") {
      const htmlElem = document?.documentElement?.classList
      htmlElem.add("ter-app--scroll-locked")
      document.body.style.overflow = "hidden";
      document.getElementById("___gatsby").style.overflow = "hidden"; // prevents weird overscroll issue
    } else {
      document.body.style.overflow = "";
      document.getElementById("___gatsby").style.overflow = "";
      const htmlElem = document?.documentElement?.classList
      htmlElem.remove("ter-app--scroll-locked")
    }
  }, [mobileNavOpen])

  const checkScroll = () => {
    if (!hamburgerIsOpen) {
      const position = window?.scrollY
      if (
        typeof position !== undefined &&
        position > lastPositionRef.current + 100
      ) {
        setIsHidden(true)
        setLastPosition(position)
        setCurrentOpenMenu(null)
        setCurrentOpenMegaMenu(null)
      } else if (
        typeof position !== undefined &&
        position < lastPositionRef.current
      ) {
        setIsHidden(false)
        setLastPosition(position)
      }
      // handleBottomBar(position);
    }
  }

  const onSearch = value => {
    navigate(`?search=${value}`, { replace: false })
    setDesktopSearchDeployed(false)
    setSearchDeployed(false)
  }

  // const onSearch = (string) => {
  //   if (string && string.length && history) {
  //     const languageCode = data?.language?.substring(0, 2);
  //     const url = languageEnabled
  //       ? `/${languageCode}/search?${string}`
  //       : `/search?${string}`;
  //     history.push(url);
  //     return;
  //   } else if (string && string.length) {
  //     // Do Gatsby push w/e
  //     // TODO - Figure out Gatsby push for Search Submit
  //   }
  // };

  const handleLanguageSelectorDeployed = () => {
    setLanguageSelectorDeployed(!languageSelectorDeployed);
  }

  const handleSectorFlyoutDeployed = flyoutDeployed => {
    const isTokenValid = timeStamp => getTrialFormId(Number(timeStamp))
    const getTIDAuth = () => {
      const TIDAuth = JSON?.parse(localStorage.getItem("user-trial-data"))

      // MAKE SURE THAT THE USER IS AUTHENTICATED AND THAT THE TOKEN IS STILL VALID
      if (TIDAuth && isTokenValid(TIDAuth?.time)) {
        return TIDAuth
      }
      return null
    }

    const activeToken = getTIDAuth()

    // Refresh Auth Token if necessary
    if (!activeToken && JSON?.parse(localStorage.getItem("user-trial-data"))) {
      refreshAuthToken(
        refreshTokenKeys?.client_id,
        refreshTokenKeys?.client_secret,
        refreshTokenKeys?.redirect_uri,
        refreshTokenKeys?.code_verifier,
        refreshTokenKeys?.path,
        process.env.GATSBY_ENV === "staging"
          ? "https://stage.id.trimblecloud.com/oauth/token"
          : "https://id.trimble.com/oauth/token"
      )
    
    }
      setSectorFlyoutOpen(
        flyoutDeployed === undefined ? !sectorFlyoutOpen : flyoutDeployed
      )
  }
  const closeAllDropDowns = e => {
    if(languageSelectorDeployed != false) {
      setLanguageSelectorDeployed(!languageSelectorDeployed)
    } 
    // setSectorFlyoutOpen(false);
    if (!navRef?.current?.contains(e?.target)) {
      setCurrentOpenMegaMenu(null)
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("click", e => closeAllDropDowns(e))
      window.addEventListener("scroll", checkScroll)
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("click", e => closeAllDropDowns(e))
        window.removeEventListener("scroll", checkScroll)
      }
    }
  }, [])

  const utilityNavMenuData = {
    cartData: cartData,
    cartSettings: cartSettings,
    waffleMenuData: data?.waffleMenu,
    userProfile: data?.userProfile,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
    languageSelectorDeployed: languageSelectorDeployed,
    setLanguageSelectorDeployed: setLanguageSelectorDeployed,
    disableLanguageRegion: data?.disableLanguageRegion,
    searchDeployed: searchDeployed,
    setSearchDeployed: setSearchDeployed,
    disableCartFlyout:
      !process.env.GATSBY_ECOMM_ENABLED ||
      process.env.GATSBY_ECOMM_ENABLED != "true"
        ? true
        : data?.disableCartFlyout,
    cartSettings: cartSettings,
    defaultCurrency: defaultCurrency,
    currencies: currencies,
    isCurrencyLocked: isCurrencyLocked,
    setCurrency: setCurrency,
    activeCurrency: activeCurrency,
    saveLanguage: saveLanguage,
    languageSelectorData: data?.languageSelectorData,
    setDesktopSearchDeployed: setDesktopSearchDeployed,
    desktopSearchDeployed: desktopSearchDeployed,
    onSearch: onSearch,
    searchComponent: searchComponent,
    searchField: "",
    // searchFlyoutSubmit: searchFlyoutSubmit,
    sectorFlyoutDeployed: sectorFlyoutOpen,
    setSectorFlyoutDeployed: setSectorFlyoutDeployed,
    sectorFlyoutData: {
      ...flyout,
      setDesktopSearchDeployed: setDesktopSearchDeployed,
      setGlobalSearch: setGlobalSearch,
      Link: Link
    },
    handleSectorFlyoutDeployed: handleSectorFlyoutDeployed,
    // disableSearch: data?.disableSearch,
    disableFlyout: data?.disableSectorFlyOut,
    isCartFlyoutOpen: isCartFlyoutActive,
    onCartFlyoutOpen: setCartFlyoutActive,
    onCartRemoveItem: onCartRemoveItem,
    onCartChangeQuantity: onCartChangeQuantity,
    // loginPage: () => data?.loginPage(),
    // logout: () => data?.logout(),
    isAuthenticated: flyout?.authenticated,
    // authLabels: data?.authLabels,
    setGlobalSearch: setGlobalSearch,
    globalSearch: globalSearch,
  }

  const mainNavMenuData = {
    navItems: data?.navOptions,
    navCta: data?.navCTA,
    currentOpenMegaMenu,
    setCurrentOpenMegaMenu,
    mobileNavOpen,
    setMobileNavOpen,
  }

  const mainNavLogo = {
    src: data?.logo?.url,
    url: data?.logo?.link?.url,
    altText: data?.logo?.altText,
    Link: Link,
  }

  return (
    <>
      <nav
        ref={navRef}
        className={`ter-navbar ter-navbar${
          isHidden && window?.scrollY > 100 && !desktopSearchDeployed
            ? "--is-hidden"
            : "--is-showing"
        } ter-navbar--new-nav`}
      >
        {mainNavMenuData && (
          <SiteNavigation
            LinkComponent={Link}
            sectorName={data?.divisionName}
            utilityNavMenu={utilityNavMenuData}
            mainNavMenu={mainNavMenuData}
            logo={mainNavLogo}
          />
        )}
        {subNavDisplay === true && (
          <SubNav
            Link={Link}
            breadcrumbs={innerPageNavData?.breadcrumbs}
            siblings={innerPageNavData?.siblingPages}
            isHidden={isHidden}
          />
        )}
        {onPageNavData?.navItems?.length > 0 && (
          <OnPageNav
            navCta={onPageNavData?.navCta}
            navTitle={onPageNavData?.navTitle}
            navItems={onPageNavData?.navItems}
          />
        )}
        {alertHolderComponent && alertHolderComponent}
        {showJumpNav === true && (
          <InPageJumpNav pageSections={jumpNavItems} navType="horizontal" />
        )}
      </nav>
    </>
  )
}

export default SiteNavigationHandler
